/**
 * Load customer-visible live-card elements for admin intake / lead details.
 * Uses the public lead-intake manifest (legacy hydrate) so Access/Add-ons
 * appear even when the live card has no explicit `elements[]` yet.
 */

import api from "@/shared/api";
import { filterCustomerIntakeElements } from "./customerIntakeElements.js";
import { normalizePriceCardElement } from "@/features/priceCard/services/priceCardElementService.js";

const unwrapResponse = (response) =>
  response?.data?.data ?? response?.data ?? response ?? {};

/**
 * @returns {Promise<{ card: object|null, elements: object[] }>}
 */
export async function getLeadIntakeElementManifest() {
  const response = await api.get("/public/pricing/lead-intake-elements", {
    skipAuth: true,
  });
  const payload = unwrapResponse(response);
  const card = payload?.card || null;
  const raw = Array.isArray(payload)
    ? payload
    : payload?.elements || payload?.items || payload?.results || [];
  const elements = filterCustomerIntakeElements(
    raw
      .map((element) => normalizePriceCardElement(element, card || {}))
      .filter((element) => element.id),
  );
  return { card, elements };
}
